(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[220],{

/***/ 27820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _read_ui_Cover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35393);
/* harmony import */ var _utils_URL__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41688);




const BookCover = (props)=>{
    const { bookInfo , width =52 , src , ...restProps } = props;
    const { bookId ="" , coverId  } = bookInfo;
    const coverUrl = (0,_utils_URL__WEBPACK_IMPORTED_MODULE_3__/* .bookcover */ .oq)(bookId, width * 2, coverId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_read_ui_Cover__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        src: coverUrl,
        width: width,
        ...restProps
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BookCover);


/***/ }),

/***/ 68307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _read_ui_util_type__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44024);
/* harmony import */ var _read_ui_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65378);
/* harmony import */ var _read_ui_InputBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68840);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_appManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3786);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53474);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _IntersectionObserver__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3075);
/* harmony import */ var _QDReport__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73393);












const HeaderLogoSize = (0,_read_ui_util_type__WEBPACK_IMPORTED_MODULE_9__/* .tuple */ .b)("small", "auto");
const Header = (param)=>{
    let { isFixed =true , children , className ="" , logoSize ="auto" , search  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const handleClick = async ()=>{
        (0,_utils_appManager__WEBPACK_IMPORTED_MODULE_6__/* .openApp */ .CB)({
            router,
            afQuery: {
                af_adset: _utils_appManager__WEBPACK_IMPORTED_MODULE_6__/* .AF_ADSET.header_download */ .en.header_download
            }
        });
    };
    const downloadReport = {
        uiname: "topdownload",
        dl: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "w100% df h48 bc_fff aic jcc ".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().header), " ").concat(isFixed ? "pf t0 l0" : "pr", " ").concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "g_wrap df aic w100% ".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().headerInner)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/?refer=header",
                            rel: "nofollow",
                            className: "w32 h32 dib mr16 ".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().logo), " _").concat(logoSize),
                            title: "Webnovel",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "dn",
                                children: "Chereads"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "f1 mr16",
                            children: search && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_read_ui_InputBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: "ff_sans fs14 fw400",
                                size: "sm",
                                placeholder: "Search"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IntersectionObserver__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            Component: _read_ui_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                            size: "xs",
                            onClick: handleClick,
                            report: downloadReport,
                            ...(0,_QDReport__WEBPACK_IMPORTED_MODULE_8__/* .toDomProps */ .Qy)(downloadReport),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "ff_sans fs12 lh16 fw700 ls1",
                                children: "DOWNLOAD APP"
                            })
                        })
                    ]
                })
            }),
            isFixed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "db h48"
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(Header));


/***/ }),

/***/ 90898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Subject; }
});

// UNUSED EXPORTS: getServerSideProps

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/URL.ts
var URL = __webpack_require__(41688);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/components/Tabs/index.module.scss
var index_module = __webpack_require__(31518);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/Tabs/index.js
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 




const Tabs = (props)=>{
    var ref;
    const { items , defaultActiveKey , activeKey , tabBarGutter =16 , tabBarStyle , tabBarClassName , activeTabClassName , contentClassName , onChange , onTabClick , className , disableShowDefault =false , destroyInactiveTabPane =false , ...restProps } = props;
    var ref1;
    const defaultKey = (ref1 = defaultActiveKey !== null && defaultActiveKey !== void 0 ? defaultActiveKey : activeKey) !== null && ref1 !== void 0 ? ref1 : (ref = items[0]) === null || ref === void 0 ? void 0 : ref.key;
    const [_activeKey, _setActiveKey] = (0,react.useState)(disableShowDefault ? "" : defaultKey);
    const [shadow, setShadow] = (0,react.useState)({
        left: false,
        right: false
    });
    const [indicatorPosition, setIndicatorPosition] = (0,react.useState)();
    const TabsRef = (0,react.useRef)(null);
    const renderedList = (0,react.useRef)([]);
    const getEleRectByKey = (key)=>{
        var ref;
        const tab = (ref = TabsRef.current) === null || ref === void 0 ? void 0 : ref.getElementsByClassName(key);
        if (tab) {
            const target = tab[0];
            var ref1, ref2;
            return {
                width: (ref1 = target === null || target === void 0 ? void 0 : target.clientWidth) !== null && ref1 !== void 0 ? ref1 : 0,
                left: (ref2 = target === null || target === void 0 ? void 0 : target.offsetLeft) !== null && ref2 !== void 0 ? ref2 : 0
            };
        }
        var _width, _left;
        return {
            width: (_width = indicatorPosition.width) !== null && _width !== void 0 ? _width : 0,
            left: (_left = indicatorPosition.left) !== null && _left !== void 0 ? _left : 0
        };
    };
    const onTabsScroll = (0,react.useCallback)(lodash_default().throttle(()=>{
        const target = TabsRef.current;
        if (target) {
            const { scrollLeft , scrollWidth , clientWidth  } = target;
            setShadow({
                left: scrollLeft > 0,
                right: scrollWidth - scrollLeft > clientWidth
            });
        }
    }, 500), []);
    // 与外部传进来的 activeKey 同步
    (0,react.useEffect)(()=>{
        if (activeKey) {
            _setActiveKey(activeKey);
        }
    }, [
        activeKey
    ]);
    (0,react.useEffect)(()=>{
        onTabsScroll();
        if (!_activeKey) {
            return;
        }
        const rect = getEleRectByKey(_activeKey);
        if (rect) {
            setIndicatorPosition({
                width: rect.width,
                left: rect.left
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        _activeKey
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((index_module_default()).nav),
        ...restProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((index_module_default()).tabsLayout, {
                    [(index_module_default()).leftShadow]: shadow.left,
                    [(index_module_default()).rightShadow]: shadow.right
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((index_module_default()).tabs, className),
                    ref: TabsRef,
                    onScroll: onTabsScroll,
                    children: [
                        items.map((param)=>{
                            let { key , label  } = param;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((index_module_default()).tab, tabBarClassName, key, {
                                    [activeTabClassName]: activeTabClassName && key === _activeKey
                                }),
                                onClick: (e)=>{
                                    _setActiveKey(key);
                                    onChange === null || onChange === void 0 ? void 0 : onChange(key);
                                    onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(key, e);
                                },
                                onMouseEnter: (e)=>{
                                    const target = e.target;
                                    setIndicatorPosition({
                                        width: target.clientWidth,
                                        left: target.offsetLeft
                                    });
                                },
                                onMouseLeave: ()=>{
                                    if (!_activeKey) {
                                        var ref;
                                        setIndicatorPosition({
                                            width: 0,
                                            left: (ref = indicatorPosition === null || indicatorPosition === void 0 ? void 0 : indicatorPosition.left) !== null && ref !== void 0 ? ref : 0
                                        });
                                        return;
                                    }
                                    const rect = getEleRectByKey(_activeKey);
                                    if (rect) {
                                        setIndicatorPosition({
                                            width: rect.width,
                                            left: rect.left
                                        });
                                    }
                                },
                                style: {
                                    marginRight: tabBarGutter,
                                    ...tabBarStyle !== null && tabBarStyle !== void 0 ? tabBarStyle : {}
                                },
                                children: label
                            }, key);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default()).indicator,
                            style: {
                                width: indicatorPosition === null || indicatorPosition === void 0 ? void 0 : indicatorPosition.width,
                                left: indicatorPosition === null || indicatorPosition === void 0 ? void 0 : indicatorPosition.left
                            }
                        })
                    ]
                })
            }),
            items.map((param)=>{
                let { key , children , forceRender  } = param;
                const active = _activeKey === key;
                const hasRendered = renderedList.current.includes(key);
                const recordRendered = ()=>{
                    if (!hasRendered) {
                        renderedList.current.push(key);
                    }
                };
                const content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((index_module_default()).content, contentClassName),
                    children: children
                }, key);
                if (!active) {
                    // 不是当前激活的 tab，且设置了销毁dom，则不渲染
                    if (destroyInactiveTabPane) {
                        return null;
                    }
                    if (hasRendered || forceRender) {
                        recordRendered();
                        return /*#__PURE__*/ (0,react.cloneElement)(content, {
                            style: {
                                display: "none"
                            }
                        });
                    }
                    return null;
                }
                /* ---- active ---- */ recordRendered();
                return content;
            })
        ]
    });
};
/* harmony default export */ var components_Tabs = (Tabs);

// EXTERNAL MODULE: ./src/read-ui/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(7249);
// EXTERNAL MODULE: ./node_modules/webnovel-icons/dist/index.js
var dist = __webpack_require__(99673);
// EXTERNAL MODULE: ./src/components/BetterPagination/index.module.scss
var BetterPagination_index_module = __webpack_require__(47205);
var BetterPagination_index_module_default = /*#__PURE__*/__webpack_require__.n(BetterPagination_index_module);
;// CONCATENATED MODULE: ./src/components/BetterPagination/index.js
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ 





const Pagination = (props)=>{
    const { current: _current , showMaxPageCount =7 , pageSize =10 , total =0 , defaultCurrent =1 , // defaultPageSize = 10,
    position ="center" , className , itemClassName , onChange , itemRender  } = props;
    // 内部的 current
    const [current, setCurrent] = (0,react.useState)(_current !== null && _current !== void 0 ? _current : defaultCurrent);
    const totalPageNum = Math.ceil(total / pageSize);
    const handlePageNum = ()=>{
        // 移动端不适合展示多页的分页列表，因此只展示当前页的页码
        return [
            current
        ];
    };
    var ref;
    const handleItemRender = (page, type, originalElement)=>{
        return (ref = itemRender === null || itemRender === void 0 ? void 0 : itemRender(page, type, originalElement)) !== null && ref !== void 0 ? ref : originalElement;
    };
    const onPageClick = (page)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(page, pageSize);
        setCurrent(page);
    };
    const positionMap = {
        left: "flex-start",
        center: "center",
        right: "flex-end"
    };
    (0,react.useEffect)(()=>{
        if (_current) {
            setCurrent(_current);
        }
    }, [
        _current
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((BetterPagination_index_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (BetterPagination_index_module_default()).pageList,
            style: {
                justifyContent: positionMap[position]
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: classnames_default()((BetterPagination_index_module_default()).page, itemClassName, {
                        [(BetterPagination_index_module_default()).disable]: current === 1
                    }),
                    onClick: ()=>onPageClick(current - 1),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            className: "mt-2",
                            Svg: dist/* IChevronLeft */.PQr,
                            size: 24
                        }),
                        handleItemRender(current - 1, "prev", "PREV")
                    ]
                }, "prev"),
                handlePageNum().map((num)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()((BetterPagination_index_module_default()).page, itemClassName, {
                            [(BetterPagination_index_module_default()).active]: current === num,
                            [(BetterPagination_index_module_default()).omission]: !num
                        }),
                        onClick: ()=>onPageClick(num !== null && num !== void 0 ? num : current),
                        children: handleItemRender(num, "page", num)
                    }, num);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: classnames_default()((BetterPagination_index_module_default()).page, itemClassName, {
                        [(BetterPagination_index_module_default()).disable]: current >= totalPageNum
                    }),
                    onClick: ()=>onPageClick(current + 1),
                    children: [
                        handleItemRender(current + 1, "next", "NEXT"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            className: "mt-2",
                            Svg: dist/* IChevronRight */.b_v,
                            size: 24
                        })
                    ]
                }, "next")
            ]
        })
    });
};
/* harmony default export */ var BetterPagination = (Pagination);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/pages/Subject/SubjectList/List/index.module.scss
var List_index_module = __webpack_require__(85165);
var List_index_module_default = /*#__PURE__*/__webpack_require__.n(List_index_module);
;// CONCATENATED MODULE: ./src/pages/Subject/SubjectList/List/index.tsx






const SubjectList = (props)=>{
    const { list , className , ...restProps } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((List_index_module_default()).container, className),
        ...restProps,
        children: list.map((item)=>{
            const { searchWord , topicId  } = item;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,URL/* getHost */.XF)() + (0,URL/* getSubjectDetailUrl */.pQ)("".concat(topicId)),
                title: searchWord,
                className: classnames_default()((List_index_module_default()).item, "ell"),
                children: searchWord
            }, topicId);
        })
    });
};
/* harmony default export */ var List = (SubjectList);

// EXTERNAL MODULE: ./src/components/Helmet.tsx + 1 modules
var Helmet = __webpack_require__(30258);
;// CONCATENATED MODULE: ./src/pages/Subject/SubjectList/SubjectListHelmet/index.tsx




const SubjectHelmet = (props)=>{
    const { tabName ="" , pageIndex =1 , list =[]  } = props;
    const handleTitle = ()=>{
        let dynamic = "";
        if (!tabName) {
            // 首页
            dynamic = "";
        } else {
            // 非首页
            dynamic = tabName.toUpperCase() + (pageIndex > 1 ? "_".concat(pageIndex) : "");
        }
        return [
            "All Story Types Read Online",
            dynamic,
            "WebNovel"
        ].filter((v)=>v).join(" - ");
    };
    const handleDesc = ()=>{
        const keywordsList = list.slice(0, 3).join(", ");
        return "The data of story types are derived from search keywords and tags describing novels or stories. We offers a vast collection of popular web novels in every genre, like Romance, Fantasy, Sci-fi, ".concat(keywordsList, " etc.");
    };
    const title = handleTitle();
    const description = handleDesc();
    const keywords = "story types, novel keywords, novel tags, light fiction, web novel, good reads";
    const canonical = "".concat((0,URL/* getHost */.XF)()).concat((0,URL/* getSubjectListUrl */.di)(tabName, pageIndex));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* Helmet */.q, {
        title: title,
        description: description,
        keywords: keywords,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
            rel: "canonical",
            href: canonical
        })
    });
};
/* harmony default export */ var SubjectListHelmet = (SubjectHelmet);

// EXTERNAL MODULE: ./src/pages/Subject/SubjectList/index.module.scss
var SubjectList_index_module = __webpack_require__(5914);
var SubjectList_index_module_default = /*#__PURE__*/__webpack_require__.n(SubjectList_index_module);
// EXTERNAL MODULE: ./src/api/index.ts + 1 modules
var api = __webpack_require__(54025);
// EXTERNAL MODULE: ./src/components/Layout/Header/index.tsx
var Header = __webpack_require__(68307);
// EXTERNAL MODULE: ./src/components/Layout/ResponsiveWrap/index.tsx
var ResponsiveWrap = __webpack_require__(18648);
;// CONCATENATED MODULE: ./src/pages/Subject/SubjectList/index.tsx














const LETTERS_MAP = [
    ..."abcdefghijklmnopqrstuvwxyz".split("")
];
const pageSize = 180;
const letterToKeyword = (letter)=>{
    return letter === "#" ? "other" : letter;
};
const keywordToLetter = (keyword)=>{
    if (!keyword) {
        return undefined;
    }
    return keyword === "other" ? "#" : keyword;
};
const SubjectList_SubjectList = (props)=>{
    const { data , cate: _cate , pageIndex  } = props;
    const { keywords =[] , total =0 , isLast =false  } = data !== null && data !== void 0 ? data : {};
    const cate = _cate ? keywordToLetter(_cate) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((SubjectList_index_module_default()).container),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubjectListHelmet, {
                tabName: cate,
                pageIndex: pageIndex,
                list: keywords.slice(0, 3).map((keyword)=>keyword.searchWord)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveWrap/* default */.Z, {
                className: classnames_default()((SubjectList_index_module_default()).responsiveWrap, "pt16 pb36 pr"),
                maxWidth: 932,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Tabs, {
                        tabBarGutter: 4,
                        defaultActiveKey: cate,
                        disableShowDefault: !cate,
                        tabBarClassName: (SubjectList_index_module_default()).tabBarItem,
                        items: LETTERS_MAP.map((letter)=>{
                            const active = letter === cate;
                            return {
                                key: letter,
                                // eslint-disable-next-line no-script-url
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: active ? "javascript:;" : (0,URL/* getHost */.XF)() + (0,URL/* getSubjectListUrl */.di)(letterToKeyword(letter)),
                                    children: letter
                                }),
                                children: null
                            };
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SubjectList_index_module_default()).subjectList,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            list: keywords
                        })
                    }),
                    !!cate && /*#__PURE__*/ (0,jsx_runtime.jsx)(BetterPagination, {
                        className: (SubjectList_index_module_default()).pagination,
                        pageSize: pageSize,
                        total: total,
                        current: pageIndex,
                        itemRender: (page, type, originalElement)=>{
                            const activePage = page === +pageIndex;
                            const noPrev = page == 0 && type === "prev";
                            const noNext = isLast && type === "next";
                            const noLink = noPrev || noNext;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: noLink ? "javascript:;" : "".concat((0,URL/* getHost */.XF)()).concat((0,URL/* getSubjectListUrl */.di)(cate, page)),
                                children: originalElement
                            });
                        }
                    })
                ]
            })
        ]
    });
};
const SubjectList_subjectListGetServerSideProps = async (ctx)=>{
    var ref;
    const { query  } = ctx;
    let cate = query.cate;
    let pageIndex = "1";
    if (cate) {
        const [_letter, _pageIndex] = cate.split("_");
        cate = letterToKeyword(_letter);
        pageIndex = _pageIndex !== null && _pageIndex !== void 0 ? _pageIndex : pageIndex;
    }
    const [err, data] = await to(goPcmSeoCrTopicList({
        cate,
        pageIndex,
        pageSize: "".concat(pageSize)
    }, {}, ctx));
    if (err) {
        return {
            redirect: {
                statusCode: 302,
                destination: "/"
            }
        };
    }
    if (!(data === null || data === void 0 ? void 0 : (ref = data.keywords) === null || ref === void 0 ? void 0 : ref.length) || data.pages && data.pages < +pageIndex) {
        return {
            redirect: {
                statusCode: 302,
                destination: "/"
            }
        };
    }
    return {
        props: {
            data,
            cate: typeof cate === "undefined" ? "" : cate,
            pageIndex: +pageIndex
        }
    };
};
/* harmony default export */ var Subject_SubjectList = (SubjectList_SubjectList);

// EXTERNAL MODULE: ./src/utils/formatTools.ts
var formatTools = __webpack_require__(51394);
;// CONCATENATED MODULE: ./src/pages/Subject/SubjectDetail/SubjectDetailHelmet/index.tsx





const SubjectDetailHelmet = (props)=>{
    const { subjectWord , bookNames =[] , topicId  } = props;
    const keyWord = (0,formatTools/* toUpperCaseWords */.lr)(subjectWord);
    const title = "".concat(keyWord, " Novels & Stories - Chereads");
    const description = "Read ".concat(keyWord, " stories online for free. We provide the most popular ").concat(keyWord, " light novel like: ").concat(bookNames.slice(0, 3).join(", "), ".");
    const keywords = "".concat(keyWord, ", ").concat(keyWord, " novels, ").concat(keyWord, " stories, fanfic, fiction books, chereads");
    const canonical = "".concat((0,URL/* getHost */.XF)()).concat((0,URL/* getSubjectDetailUrl */.pQ)("".concat(topicId)));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* Helmet */.q, {
        title: title,
        description: description,
        keywords: keywords,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
            rel: "canonical",
            href: canonical
        })
    });
};
/* harmony default export */ var SubjectDetail_SubjectDetailHelmet = (SubjectDetailHelmet);

// EXTERNAL MODULE: ./src/pages/Subject/SubjectDetail/TitleCard/index.module.scss
var TitleCard_index_module = __webpack_require__(66977);
var TitleCard_index_module_default = /*#__PURE__*/__webpack_require__.n(TitleCard_index_module);
;// CONCATENATED MODULE: ./src/pages/Subject/SubjectDetail/TitleCard/index.js




const TitleCard = (props)=>{
    const { title ="" , className =""  } = props;
    if (!title) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt4 ".concat((TitleCard_index_module_default()).title_card, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            className: "".concat((TitleCard_index_module_default()).title),
            children: (0,formatTools/* toUpperCaseWords */.lr)(title)
        })
    });
};
/* harmony default export */ var SubjectDetail_TitleCard = (TitleCard);

// EXTERNAL MODULE: ./src/pages/Subject/SubjectDetail/index.module.scss
var SubjectDetail_index_module = __webpack_require__(51836);
var SubjectDetail_index_module_default = /*#__PURE__*/__webpack_require__.n(SubjectDetail_index_module);
// EXTERNAL MODULE: ./src/pages/Subject/SubjectDetail/PopularTags/index.module.scss
var PopularTags_index_module = __webpack_require__(93704);
var PopularTags_index_module_default = /*#__PURE__*/__webpack_require__.n(PopularTags_index_module);
;// CONCATENATED MODULE: ./src/pages/Subject/SubjectDetail/PopularTags/index.tsx









const PopularTags = (props)=>{
    const { className ="" , list , title  } = props;
    if (!(list === null || list === void 0 ? void 0 : list.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: className,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((PopularTags_index_module_default()).header, "mb12"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bsbb fi m0 p0 fs16 lh20 fw500 ell c_l fl",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: classnames_default()((PopularTags_index_module_default()).extraRight, "c_m fs14"),
                        href: (0,URL/* getHost */.XF)() + (0,URL/* getSubjectListUrl */.di)(),
                        children: [
                            "More",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                size: 20,
                                Svg: dist/* IChevronRight */.b_v
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    list: list.map((item)=>({
                            ...item,
                            searchWord: item.topicName
                        })),
                    className: (PopularTags_index_module_default()).list
                })
            })
        ]
    });
};
/* harmony default export */ var SubjectDetail_PopularTags = (PopularTags);

// EXTERNAL MODULE: ./src/components/Book/BookCardList/index.module.scss
var BookCardList_index_module = __webpack_require__(56189);
var BookCardList_index_module_default = /*#__PURE__*/__webpack_require__.n(BookCardList_index_module);
// EXTERNAL MODULE: ./src/interface/IBook.ts
var IBook = __webpack_require__(79611);
// EXTERNAL MODULE: ./src/components/Book/BookCover/index.tsx
var BookCover = __webpack_require__(27820);
// EXTERNAL MODULE: ./src/components/Book/BookCard/index.module.scss
var BookCard_index_module = __webpack_require__(90469);
var BookCard_index_module_default = /*#__PURE__*/__webpack_require__.n(BookCard_index_module);
;// CONCATENATED MODULE: ./src/components/Book/BookCard/index.tsx








const BookCard = (props)=>{
    const { bookInfo , handleBookLink , className , ...restProps } = props;
    const { bookId ="" , pvNum =0 , authorName , description  } = bookInfo;
    var _bookName;
    const bookName = (_bookName = bookInfo.bookName) !== null && _bookName !== void 0 ? _bookName : bookInfo.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: handleBookLink ? handleBookLink(bookInfo) : (0,URL/* composeChapterUrl */.Wo)({
            bookId,
            bookName: "",
            novelType: IBook/* BookTypeEnum.Novel */.Qt.Novel,
            isPureId: true
        }),
        className: classnames_default()((BookCard_index_module_default()).container, className),
        ...restProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookCover/* default */.Z, {
                bookInfo: bookInfo,
                width: 78,
                className: "br4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BookCard_index_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: classnames_default()((BookCard_index_module_default()).name, "ells _2"),
                        children: bookName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((BookCard_index_module_default()).desc, "ells _3"),
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BookCard_index_module_default()).extra,
                        children: "".concat(authorName, " \xb7 ").concat((0,formatTools/* formatNumber */.uf)(+pvNum).toUpperCase(), " Views")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Book_BookCard = (BookCard);

;// CONCATENATED MODULE: ./src/components/Row/interface.ts
var RowMedia;
(function(RowMedia) {
    RowMedia["xxs"] = "xxs";
    RowMedia["xs"] = "xs";
    RowMedia["md"] = "md";
})(RowMedia || (RowMedia = {}));

// EXTERNAL MODULE: ./src/components/Row/index.module.scss
var Row_index_module = __webpack_require__(98270);
var Row_index_module_default = /*#__PURE__*/__webpack_require__.n(Row_index_module);
// EXTERNAL MODULE: ./src/utils/adaptor.ts
var adaptor = __webpack_require__(80002);
;// CONCATENATED MODULE: ./src/components/Row/index.tsx






const DefaultGutter = 0;
const Row = (props)=>{
    const { gutter =DefaultGutter , children , className , style , ...restProps } = props;
    const gutterVars = (0,react.useMemo)(()=>{
        const vars = {};
        const handleGutter = function(g) {
            let key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            const rowGutterKey = "--".concat([
                "row",
                "gutter",
                key
            ].filter(Boolean).join("-"));
            const columnGutterKey = "--".concat([
                "column",
                "gutter",
                key
            ].filter(Boolean).join("-"));
            if (typeof g === "number") {
                vars[rowGutterKey] = "".concat((0,adaptor/* rem */.h)(g), "rem");
                vars[columnGutterKey] = "".concat((0,adaptor/* rem */.h)(g), "rem");
            } else if (Array.isArray(g)) {
                var ref;
                vars[rowGutterKey] = "".concat((0,adaptor/* rem */.h)((ref = g[0]) !== null && ref !== void 0 ? ref : DefaultGutter), "rem");
                var ref1;
                vars[columnGutterKey] = "".concat((0,adaptor/* rem */.h)((ref1 = g[1]) !== null && ref1 !== void 0 ? ref1 : DefaultGutter), "rem");
            }
        };
        if (typeof gutter === "number" || Array.isArray(gutter)) {
            handleGutter(gutter);
        } else if (typeof gutter === "object") {
            Object.entries(gutter).forEach((param)=>{
                let [_key, value] = param;
                // xxs 就等于是默认的移动分辨率，不需要设置key
                const key = _key === RowMedia.xxs ? "" : _key;
                handleGutter(value, key);
            });
        }
        return vars;
    }, [
        gutter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Row_index_module_default()).container, className),
        style: {
            ...style,
            ...gutterVars
        },
        ...restProps,
        children: children
    });
};
Row.displayName = "Row";
/* harmony default export */ var components_Row = (Row);

// EXTERNAL MODULE: ./src/components/Row/Col/index.module.scss
var Col_index_module = __webpack_require__(43148);
var Col_index_module_default = /*#__PURE__*/__webpack_require__.n(Col_index_module);
;// CONCATENATED MODULE: ./src/components/Row/Col/index.tsx




const Col = (props)=>{
    const { children , span , order , md , xs , className , style , ...restProps } = props;
    const handleVars = (0,react.useMemo)(()=>{
        const vars = {};
        const cls = [];
        const handleVarValue = (k, v, key)=>{
            switch(k){
                default:
                    return "";
                case "span":
                    if (!v) {
                        cls.push("col-".concat(key ? "".concat(key, "-") : "", "hidden"));
                    }
                    return "".concat(v / 24 * 100, "%");
                case "order":
                    return v;
                case "flex":
                    return v;
            }
        };
        if (typeof span !== "undefined") {
            vars["--col-span"] = handleVarValue("span", span);
        }
        Object.entries({
            md,
            xs
        }).forEach((param)=>{
            let [key, value] = param;
            if (typeof value === "undefined") {
                return;
            }
            if (typeof value === "number") {
                if (!value) {
                    cls.push("col-hidden");
                }
                vars["--col-".concat(key, "-span")] = handleVarValue("span", value);
                return;
            }
            // obj
            Object.entries(value).forEach((param)=>{
                let [k, v] = param;
                if (typeof v === "undefined") {
                    return;
                }
                vars["--col-".concat(key, "-").concat(k)] = handleVarValue(k, v, key);
            });
        });
        return [
            vars,
            cls
        ];
    }, [
        md,
        span
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Col_index_module_default()).container, {
            [(Col_index_module_default()).hidden]: handleVars[1].includes("col-hidden"),
            [(Col_index_module_default())["md-hidden"]]: handleVars[1].includes("col-md-hidden")
        }, className),
        style: {
            ...style,
            ...handleVars[0]
        },
        ...restProps,
        children: children
    });
};
Col.displayName = "Col";
/* harmony default export */ var Row_Col = (Col);

;// CONCATENATED MODULE: ./src/components/Book/BookCardList/index.tsx






const BookCardList = (props)=>{
    const { list , title , handleBookLink , className , ...restProps } = props;
    if (!(list === null || list === void 0 ? void 0 : list.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((BookCardList_index_module_default()).container, className),
        ...restProps,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((BookCardList_index_module_default()).title, "mb16 pb4 t_h6 ell c_l"),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Row, {
                className: (BookCardList_index_module_default()).list,
                gutter: {
                    md: 16,
                    xxs: 16
                },
                children: list.map((book)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_Col, {
                        span: 24,
                        md: {
                            span: 12
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Book_BookCard, {
                            handleBookLink: handleBookLink,
                            className: (BookCardList_index_module_default()).item,
                            bookInfo: book
                        })
                    }, book.bookId);
                })
            })
        ]
    });
};
/* harmony default export */ var Book_BookCardList = (BookCardList);

;// CONCATENATED MODULE: ./src/pages/Subject/SubjectDetail/index.tsx














const SubjectDetail = (props)=>{
    var ref;
    const { data  } = props;
    const { recommendInfo , relationTopics =[] , topicInfo  } = data;
    var ref1, ref2, _name, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((SubjectDetail_index_module_default()).container),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubjectDetail_SubjectDetailHelmet, {
                subjectWord: (ref1 = topicInfo === null || topicInfo === void 0 ? void 0 : topicInfo.topicName) !== null && ref1 !== void 0 ? ref1 : "",
                topicId: (ref2 = topicInfo === null || topicInfo === void 0 ? void 0 : topicInfo.topicId) !== null && ref2 !== void 0 ? ref2 : "",
                bookNames: recommendInfo === null || recommendInfo === void 0 ? void 0 : (ref = recommendInfo.contentItems) === null || ref === void 0 ? void 0 : ref.map((item)=>(_name = item.name) !== null && _name !== void 0 ? _name : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveWrap/* default */.Z, {
                className: classnames_default()((SubjectDetail_index_module_default()).responsiveWrap, "pt16 pb36 pr"),
                maxWidth: 932,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubjectDetail_TitleCard, {
                        title: topicInfo === null || topicInfo === void 0 ? void 0 : topicInfo.topicName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Book_BookCardList, {
                        list: (ref3 = recommendInfo === null || recommendInfo === void 0 ? void 0 : recommendInfo.contentItems) !== null && ref3 !== void 0 ? ref3 : [],
                        handleBookLink: (bookInfo)=>(0,URL/* getHost */.XF)() + (0,URL/* composeChapterUrl */.Wo)({
                                bookId: bookInfo.bookId,
                                bookName: "",
                                novelType: IBook/* BookTypeEnum.Novel */.Qt.Novel,
                                isPureId: true
                            })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubjectDetail_PopularTags, {
                        className: "mt32",
                        list: relationTopics,
                        title: "Related Topics"
                    })
                ]
            })
        ]
    }, topicInfo === null || topicInfo === void 0 ? void 0 : topicInfo.topicId);
};
const SubjectDetail_subjectDetailGetServerSideProps = async (ctx)=>{
    var ref;
    const { query  } = ctx;
    const topicId = query.cate;
    const [err, data] = await to(goPcmSeoCrTopicDetail({
        topicId
    }, {}, ctx));
    if (err) {
        return {
            redirect: {
                statusCode: 302,
                destination: "/"
            }
        };
    }
    // 404
    if (!((ref = data.topicInfo) === null || ref === void 0 ? void 0 : ref.topicName)) {
        return {
            redirect: {
                statusCode: 302,
                destination: "/"
            }
        };
    }
    return {
        props: {
            data,
            topicId
        }
    };
};
/* harmony default export */ var Subject_SubjectDetail = (SubjectDetail);

;// CONCATENATED MODULE: ./src/pages/Subject/index.tsx






const SubjectAdaptor = (props)=>{
    const { onlyId: _onlyId , data , ...restProps } = props;
    const router = (0,next_router.useRouter)();
    let onlyId = _onlyId;
    // 浏览器的回退/前进功能，不会走到 getInitialProps 钩子，此时 onlyId 拿不到任何值
    if (onlyId == undefined) {
        onlyId = (0,URL/* isOnlyId */.KD)(router.query.bookId);
    }
    return onlyId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Subject_SubjectDetail, {
        ...data,
        ...restProps
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Subject_SubjectList, {
        ...data,
        ...restProps
    });
};
const getServerSideProps = async function(ctx) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    const onlyId = isOnlyId(ctx.query.cate);
    /**
   * 纯id为话题详情页
   * 非纯id为话题列表页
   */ const result = onlyId ? await subjectDetailGetServerSideProps(ctx, ...args) : await subjectListGetServerSideProps(ctx, ...args);
    return {
        ...result,
        props: {
            onlyId,
            data: result.props
        }
    };
};
/* harmony default export */ var Subject = (SubjectAdaptor);


/***/ }),

/***/ 80002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ rem; }
/* harmony export */ });
// TODO: 16 得有个统一配置的地方
const rem = (px)=>px / 16;


/***/ }),

/***/ 51394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ formatBookDescByWordCount; },
/* harmony export */   "lr": function() { return /* binding */ toUpperCaseWords; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; }
/* harmony export */ });
/**
 * 数字格式化
 * 0 - 999
 * 1k - 999k
 * 1M - 999M
 * @param {number} timestamp 时间戳
 */ const formatNumber = (num)=>{
    let unit = "";
    let retNum = "-";
    if (num >= 1000000) {
        unit = "m";
        retNum = num / 1000000;
    } else if (num >= 1000) {
        unit = "k";
        retNum = num / 1000;
    } else if (num >= 0) {
        retNum = num;
    }
    // 保留1位小数，不四舍五入
    retNum = (Math.floor(Number(retNum) * 10) / 10).toFixed(1);
    retNum = retNum.split(".")[1] === "0" ? retNum.split(".")[0] : retNum;
    return retNum + unit;
};
/**
 * 格式化书简介，按词的个数截断
 * @param {*} desc
 * @param {*} format
 * @param {*} wCount 词的个数
 * @param {*} suffix
 * @returns
 */ function formatBookDescByWordCount() {
    let desc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, wCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, suffix = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const formatTxt = format ? desc.replace(/(\n|\r)+/g, "") : desc;
    const afterSplit = formatTxt.split(" ");
    const wordCount = afterSplit.length;
    let count = 0;
    let str = formatTxt;
    if (wCount) {
        str = "";
        for(let i = 0; i < wordCount; i++){
            if (count >= wCount) {
                break;
            }
            str += " ".concat(afterSplit[i]);
            count += 1;
        }
        str = str.substring(1);
    }
    return str + (wCount && count < wordCount ? suffix : "");
}
// 多人字词，设置首字母大写
const toUpperCaseWords = (words)=>{
    if (!words) {
        return "";
    }
    return words.toLowerCase().replace(/\b(\w)/g, (char)=>{
        return char.toUpperCase();
    });
};


/***/ }),

/***/ 47205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BetterPagination_container__ejP7l","pageList":"BetterPagination_pageList__oG7f_","page":"BetterPagination_page__sj25H","active":"BetterPagination_active__g2sO5","disable":"BetterPagination_disable__04vRk","omission":"BetterPagination_omission__nN_ou"};

/***/ }),

/***/ 90469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BookCard_container__R4Nt1","content":"BookCard_content__WpDkr","name":"BookCard_name__eQwP_","desc":"BookCard_desc__khjPC","extra":"BookCard_extra__MkQ8e"};

/***/ }),

/***/ 56189:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 53474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__ziRJg","headerInner":"styles_headerInner__JAhR6","logo":"styles_logo__W4LZ7"};

/***/ }),

/***/ 43148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nu_reset":"Col_nu_reset__gw5LB","aic":"Col_aic__oBrM1","aife":"Col_aife__XUZsL","aifs":"Col_aifs__4ZrE7","b0":"Col_b0__eWSD6","bct":"Col_bct__0ufWm","bn":"Col_bn__e2CA_","br0":"Col_br0__0zMwp","br100%":"Col_br100____gS8J0","bsbb":"Col_bsbb__5Zl3x","bc_fff":"Col_bc_fff__dqoRK","bc_000":"Col_bc_000__Z2Tjp","c_000":"Col_c_000__o5Ucy","c_fff":"Col_c_fff__me8DA","cb":"Col_cb__m3Lcp","cp":"Col_cp__rgMda","db":"Col_db__nzzLf","df":"Col_df__ZUy2Y","di":"Col_di___J38m","dib":"Col_dib__Q9oTK","dif":"Col_dif__0kZjA","dn":"Col_dn__me_HC","dt":"Col_dt__NHEnA","dtc":"Col_dtc__ICso9","f1":"Col_f1___Mdmv","fa":"Col_fa__l4sO2","fdc":"Col_fdc__aqMfO","fdr":"Col_fdr__6EQW2","fi":"Col_fi__OfC21","fl":"Col_fl__RUHKd","fr":"Col_fr__gSNDC","fs0":"Col_fs0__FKPoU","fs1":"Col_fs1__LBCuO","fsi":"Col_fsi__NDpFl","fsn":"Col_fsn__jxR_0","fvsc":"Col_fvsc__z_XEs","fw100":"Col_fw100__2Xp_L","fw200":"Col_fw200__GtlbA","fw300":"Col_fw300__4OMH0","fw400":"Col_fw400__99xLv","fw500":"Col_fw500__1yAFI","fw600":"Col_fw600__8g6aC","fw700":"Col_fw700__u56Bc","fw800":"Col_fw800__pAInB","fw900":"Col_fw900__foLwU","fwn":"Col_fwn__MdPxo","fww":"Col_fww__IKxy1","h100%":"Col_h100____BDYuo","jcc":"Col_jcc__jZ6v2","jcfe":"Col_jcfe__jXPhB","jcsa":"Col_jcsa__y7Q5G","jcsb":"Col_jcsb__DmrAc","l0":"Col_l0__kmjPR","l100%":"Col_l100____jfNnq","l50%":"Col_l50____Nse7C","lh1":"Col_lh1__otal9","lh1.2":"Col_lh1__2___qbQ6","lh1.5":"Col_lh1__5__71YN0","lh1.8":"Col_lh1__8__6hldZ","lsn":"Col_lsn__7mb3m","m0":"Col_m0__PvN0P","mla":"Col_mla__kEJRx","mra":"Col_mra__AQGS4","mta":"Col_mta__eAOU5","mba":"Col_mba__zYZ4R","o0":"Col_o0__hqlFZ","oa":"Col_oa__exope","oh":"Col_oh__tXbNY","p0":"Col_p0__X0Pgm","pa":"Col_pa__cUAet","pen":"Col_pen__zQA52","pf":"Col_pf__OwL1D","pr":"Col_pr__2Wt3O","pt100%":"Col_pt100____tEbuC","r0":"Col_r0__rX3Ij","r100%":"Col_r100____nDCgc","t0":"Col_t0__Sqd2S","t100%":"Col_t100____L0_iY","t50%":"Col_t50____h5e26","mw100%":"Col_mw100____ch_w9","tac":"Col_tac__4ipOY","taj":"Col_taj__pLmLi","tal":"Col_tal__gpetQ","tar":"Col_tar__rzmp6","tdn":"Col_tdn__I53YR","tdu":"Col_tdu__nQmJi","tlf":"Col_tlf__FMYdl","ttc":"Col_ttc__suMkI","ttl":"Col_ttl__8aJcu","ttn":"Col_ttn__W0AT4","ttu":"Col_ttu__6GU8p","usn":"Col_usn__BdYNI","vam":"Col_vam__Bt6tF","vat":"Col_vat__yp8Ol","vh":"Col_vh__RlxXZ","w100%":"Col_w100____UpehU","wan":"Col_wan__liTQs","wsn":"Col_wsn___azLc","wwbw":"Col_wwbw__4Cnjm","zi1":"Col_zi1__oKapE","mt0":"Col_mt0__lifhS","mt-2":"Col_mt-2__PGSvQ","mt2":"Col_mt2__UnDa2","mt4":"Col_mt4__nuCRq","mt-4":"Col_mt-4__pDUV_","mt8":"Col_mt8__skhwb","mt-8":"Col_mt-8__u21Hu","mt12":"Col_mt12__tV1C0","mt-12":"Col_mt-12__YKgCo","mt16":"Col_mt16__6BNd_","mt-16":"Col_mt-16__reAKe","mt20":"Col_mt20__bYj__","mt24":"Col_mt24__qdzm3","mt32":"Col_mt32__MslJd","mt36":"Col_mt36___hC5q","mt40":"Col_mt40__C0KtL","mt48":"Col_mt48__AklU6","mr0":"Col_mr0__6txRF","mr-2":"Col_mr-2__D9mkz","mr2":"Col_mr2__ioalb","mr4":"Col_mr4__AOZPt","mr-4":"Col_mr-4__kbcwn","mr8":"Col_mr8__V8wGT","mr-8":"Col_mr-8__79_bm","mr12":"Col_mr12__7m3iC","mr-12":"Col_mr-12__h5kWW","mr16":"Col_mr16__bmtMG","mr-16":"Col_mr-16__FcWJH","mr20":"Col_mr20__ivMMp","mr24":"Col_mr24__zqw_S","mr32":"Col_mr32___pUFA","mr36":"Col_mr36__IL4zk","mr40":"Col_mr40__YCEBS","mr48":"Col_mr48__T2f1u","mb0":"Col_mb0__QHfsP","mb-2":"Col_mb-2__7BpNW","mb2":"Col_mb2__Pp7GI","mb4":"Col_mb4__pNRyM","mb-4":"Col_mb-4__UQE0L","mb8":"Col_mb8__8ndfC","mb-8":"Col_mb-8__kDJ_C","mb12":"Col_mb12__HUniq","mb-12":"Col_mb-12__oT9e8","mb16":"Col_mb16__Pd4k2","mb-16":"Col_mb-16__aUKek","mb20":"Col_mb20__umew8","mb24":"Col_mb24__LpXuf","mb32":"Col_mb32__X2_Nw","mb48":"Col_mb48__M7GoM","mb36":"Col_mb36__4FshY","mb40":"Col_mb40__HE2Bx","ml0":"Col_ml0__dGpxU","ml-2":"Col_ml-2__VtKJh","ml2":"Col_ml2__mc_kc","ml4":"Col_ml4__P2L_l","ml-4":"Col_ml-4__eRqVD","ml8":"Col_ml8__h9Mtr","ml-8":"Col_ml-8___x_y1","ml12":"Col_ml12__BoRET","ml-12":"Col_ml-12__9BfAB","ml16":"Col_ml16__cebKU","ml-16":"Col_ml-16__09fRB","ml20":"Col_ml20__1BdSd","ml24":"Col_ml24__67qa_","ml32":"Col_ml32__CoAmF","ml36":"Col_ml36__lwsHH","ml40":"Col_ml40__UIwjj","ml48":"Col_ml48__l2QZw","pt0":"Col_pt0__N_eF9","pt-2":"Col_pt-2__dPxTU","pt2":"Col_pt2__3Mknf","pt4":"Col_pt4__vhjXi","pt-4":"Col_pt-4__iOkzr","pt8":"Col_pt8__LSi3Z","pt-8":"Col_pt-8__fy4YT","pt12":"Col_pt12__FnnEL","pt-12":"Col_pt-12__neR1Z","pt16":"Col_pt16__DNukW","pt-16":"Col_pt-16__628Vz","pt20":"Col_pt20__KNuk_","pt24":"Col_pt24__CN8NS","pt32":"Col_pt32__L_W3M","pt36":"Col_pt36__CirgQ","pt40":"Col_pt40__NJWwQ","pt48":"Col_pt48__a6BAK","pr0":"Col_pr0__50c_u","pr-2":"Col_pr-2__P4DwC","pr2":"Col_pr2__WODeK","pr4":"Col_pr4__UJxtA","pr-4":"Col_pr-4__xnoug","pr8":"Col_pr8__V_kzP","pr-8":"Col_pr-8__SJxn6","pr12":"Col_pr12__wz6_c","pr-12":"Col_pr-12__xSknE","pr16":"Col_pr16__yop93","pr-16":"Col_pr-16__Bt0XN","pr20":"Col_pr20__OyLsR","pr24":"Col_pr24__iziOV","pr32":"Col_pr32__6tbcr","pr36":"Col_pr36__VfSYG","pr40":"Col_pr40__VnxM9","pr48":"Col_pr48___XZsD","pb0":"Col_pb0__Oe09q","pb-2":"Col_pb-2__zL__i","pb2":"Col_pb2__wifpD","pb4":"Col_pb4__sBN_m","pb-4":"Col_pb-4__ObMMo","pb8":"Col_pb8__9vyi9","pb-8":"Col_pb-8__7nMBd","pb12":"Col_pb12__ns_8e","pb-12":"Col_pb-12__eyZxM","pb16":"Col_pb16__1nmhZ","pb-16":"Col_pb-16__eAEi6","pb20":"Col_pb20__MaBpR","pb24":"Col_pb24__gwMmo","pb32":"Col_pb32__7Nh9R","pb48":"Col_pb48__fAYeX","pb36":"Col_pb36__Dqt8j","pb40":"Col_pb40__9U39r","pl0":"Col_pl0__l4TmR","pl-2":"Col_pl-2__KtNdq","pl2":"Col_pl2__PjDo3","pl4":"Col_pl4__SjJQT","pl-4":"Col_pl-4__JhIBV","pl8":"Col_pl8___qCNi","pl-8":"Col_pl-8__QUiDq","pl12":"Col_pl12__ohfnd","pl-12":"Col_pl-12__38nn0","pl16":"Col_pl16__3oFWH","pl-16":"Col_pl-16__jQzpH","pl20":"Col_pl20__4cUJh","pl24":"Col_pl24__gygoR","pl32":"Col_pl32__YO1F2","pl36":"Col_pl36__jXCbt","pl40":"Col_pl40__3I_d4","pl48":"Col_pl48__RF_Yt","fs12":"Col_fs12__FDbOF","fs14":"Col_fs14__qViFW","fs16":"Col_fs16__VLPXt","fs18":"Col_fs18__hUvxY","fs20":"Col_fs20___DSAI","fs24":"Col_fs24__jPpCu","fs32":"Col_fs32__6USVs","lh16":"Col_lh16__ddrMm","lh20":"Col_lh20__yFVVD","lh24":"Col_lh24__4bJSm","lh32":"Col_lh32__CJ0Hg","lh40":"Col_lh40__zO8s7","w16":"Col_w16__pBt1z","w32":"Col_w32__Ah_QX","w36":"Col_w36__5JI0p","w48":"Col_w48__2vttx","h16":"Col_h16__q75jP","h24":"Col_h24__Daz1q","h32":"Col_h32__iRlFw","h40":"Col_h40__cZAEE","h48":"Col_h48__Pr3_Q","br2":"Col_br2__X97oQ","br4":"Col_br4__I2sM_","br8":"Col_br8__w4AEe","br16":"Col_br16__3fHgd","br24":"Col_br24__YQqzP","br32":"Col_br32__o7B_l","zi100":"Col_zi100__TIcjx","zi200":"Col_zi200__pm4go","clearfix":"Col_clearfix__RsVir","ell":"Col_ell__Wonhn","ells":"Col_ells__QI01h","_1":"Col__1__3Qb4L","_2":"Col__2__TnJte","_3":"Col__3__wfYyW","_4":"Col__4__2U3jj","_5":"Col__5__FafSf","c_primary":"Col_c_primary__mtndI","c_l":"Col_c_l___bz7k","c_m":"Col_c_m__Ol9IO","c_s":"Col_c_s__a0bk6","ywfont":"Col_ywfont__BRugY","container":"Col_container__mjMj7","hidden":"Col_hidden__7JmOv","xs-hidden":"Col_xs-hidden__bKCkz","md-hidden":"Col_md-hidden__7QV3i"};

/***/ }),

/***/ 98270:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nu_reset":"Row_nu_reset__4PuRq","aic":"Row_aic__mIAEr","aife":"Row_aife__EtVLa","aifs":"Row_aifs__5qO76","b0":"Row_b0__nI0BI","bct":"Row_bct__U3zlc","bn":"Row_bn__6y_qX","br0":"Row_br0__PgMBJ","br100%":"Row_br100____6iQ7q","bsbb":"Row_bsbb__MGqn6","bc_fff":"Row_bc_fff__JBUhz","bc_000":"Row_bc_000__OFnU5","c_000":"Row_c_000__GTCsg","c_fff":"Row_c_fff__n4sUg","cb":"Row_cb__TTzDR","cp":"Row_cp__3XoRf","db":"Row_db__1zfpP","df":"Row_df__5TjSk","di":"Row_di__T4z8A","dib":"Row_dib__HT1T2","dif":"Row_dif__WzsUm","dn":"Row_dn__uBZAg","dt":"Row_dt__4nzAr","dtc":"Row_dtc__j1VQv","f1":"Row_f1__7wc86","fa":"Row_fa__GEfob","fdc":"Row_fdc__cdYUD","fdr":"Row_fdr__RkLOX","fi":"Row_fi__eMu3x","fl":"Row_fl__9fkM4","fr":"Row_fr__LQOYD","fs0":"Row_fs0__b4SNv","fs1":"Row_fs1__cWdZ4","fsi":"Row_fsi__jggx_","fsn":"Row_fsn__VUZZ6","fvsc":"Row_fvsc__dpox6","fw100":"Row_fw100__pnqS2","fw200":"Row_fw200__2Z6Cx","fw300":"Row_fw300__oB6Qh","fw400":"Row_fw400__2s6JR","fw500":"Row_fw500__rWuBn","fw600":"Row_fw600__nRAvQ","fw700":"Row_fw700__V2XxU","fw800":"Row_fw800__TmyK5","fw900":"Row_fw900__bA2b_","fwn":"Row_fwn__z1LGE","fww":"Row_fww__1Rk_U","h100%":"Row_h100____b_gU0","jcc":"Row_jcc__46e2Z","jcfe":"Row_jcfe__BtFqu","jcsa":"Row_jcsa__V0h6P","jcsb":"Row_jcsb__9BcTS","l0":"Row_l0__tSwPH","l100%":"Row_l100____6PJET","l50%":"Row_l50____BVcMU","lh1":"Row_lh1__q7YMq","lh1.2":"Row_lh1__2__OY3d5","lh1.5":"Row_lh1__5__SXe0I","lh1.8":"Row_lh1__8__uUf_t","lsn":"Row_lsn___1vtA","m0":"Row_m0__7XB4R","mla":"Row_mla___rV_I","mra":"Row_mra__pNaKi","mta":"Row_mta__d0u5Y","mba":"Row_mba__Pv4UE","o0":"Row_o0__OeUmp","oa":"Row_oa__iDFws","oh":"Row_oh__QqxHE","p0":"Row_p0__ptWmc","pa":"Row_pa__sO_8m","pen":"Row_pen__T_BvG","pf":"Row_pf__Lr6mu","pr":"Row_pr__nuebs","pt100%":"Row_pt100____NZXE_","r0":"Row_r0__3Kp71","r100%":"Row_r100____k4wPz","t0":"Row_t0__i3_yy","t100%":"Row_t100____EYdMc","t50%":"Row_t50____NjOlU","mw100%":"Row_mw100____DqNt2","tac":"Row_tac__BIN9f","taj":"Row_taj__aVyie","tal":"Row_tal__cgCa7","tar":"Row_tar__zwAWL","tdn":"Row_tdn__ppyYl","tdu":"Row_tdu__Y8oIs","tlf":"Row_tlf__f3f4m","ttc":"Row_ttc__lmjub","ttl":"Row_ttl__W9Q_U","ttn":"Row_ttn__oxlR0","ttu":"Row_ttu__QRqC7","usn":"Row_usn__2y79G","vam":"Row_vam__8YBam","vat":"Row_vat__BCAvk","vh":"Row_vh__UvUF7","w100%":"Row_w100____oEnW5","wan":"Row_wan__8OLuN","wsn":"Row_wsn__eUMcU","wwbw":"Row_wwbw__5xlIH","zi1":"Row_zi1__T59mq","mt0":"Row_mt0__XdRRU","mt-2":"Row_mt-2__bu0PT","mt2":"Row_mt2__sPwDz","mt4":"Row_mt4__MA3AQ","mt-4":"Row_mt-4__Ipc_K","mt8":"Row_mt8__BsiSi","mt-8":"Row_mt-8__HLQ4F","mt12":"Row_mt12__iuA7A","mt-12":"Row_mt-12__yggIx","mt16":"Row_mt16__8UeSp","mt-16":"Row_mt-16__V5wqf","mt20":"Row_mt20__RogFf","mt24":"Row_mt24__t2Vg2","mt32":"Row_mt32__5WLsi","mt36":"Row_mt36__hsGvO","mt40":"Row_mt40__DmN7U","mt48":"Row_mt48__GsvmI","mr0":"Row_mr0__MM64Q","mr-2":"Row_mr-2__2bhFC","mr2":"Row_mr2__zGhwp","mr4":"Row_mr4__kz6um","mr-4":"Row_mr-4__SMUkr","mr8":"Row_mr8__M_8x3","mr-8":"Row_mr-8__iWo3G","mr12":"Row_mr12__MjUJ3","mr-12":"Row_mr-12__8g1z0","mr16":"Row_mr16__934WV","mr-16":"Row_mr-16__Iv4h3","mr20":"Row_mr20__Yt4_m","mr24":"Row_mr24__UOR_Q","mr32":"Row_mr32__Soess","mr36":"Row_mr36__QKY5H","mr40":"Row_mr40__PGGT6","mr48":"Row_mr48___nTAi","mb0":"Row_mb0__tgW80","mb-2":"Row_mb-2__amOn7","mb2":"Row_mb2__u5lp6","mb4":"Row_mb4__T98pW","mb-4":"Row_mb-4__X27IS","mb8":"Row_mb8__5b_a4","mb-8":"Row_mb-8__OjgNF","mb12":"Row_mb12__p5wXf","mb-12":"Row_mb-12__t3Re8","mb16":"Row_mb16__x5nUi","mb-16":"Row_mb-16__vmQgU","mb20":"Row_mb20__Txkcu","mb24":"Row_mb24__8dUHv","mb32":"Row_mb32__WhmK1","mb48":"Row_mb48__qECY5","mb36":"Row_mb36__z2CLp","mb40":"Row_mb40__4mVh_","ml0":"Row_ml0__TvOrT","ml-2":"Row_ml-2__ZWvVr","ml2":"Row_ml2__On5On","ml4":"Row_ml4__C1Sgd","ml-4":"Row_ml-4__lBdXg","ml8":"Row_ml8__eE0Wh","ml-8":"Row_ml-8__I59q4","ml12":"Row_ml12__sS5Yh","ml-12":"Row_ml-12__1pAu6","ml16":"Row_ml16__0p7rl","ml-16":"Row_ml-16__MRCVO","ml20":"Row_ml20__XtSE5","ml24":"Row_ml24__LiEUY","ml32":"Row_ml32__08_bx","ml36":"Row_ml36__P6V_A","ml40":"Row_ml40__V4yPD","ml48":"Row_ml48__9FAPT","pt0":"Row_pt0__PBbEE","pt-2":"Row_pt-2__6nBkN","pt2":"Row_pt2__tBW97","pt4":"Row_pt4__yIkTV","pt-4":"Row_pt-4__01Deu","pt8":"Row_pt8__2Hy8O","pt-8":"Row_pt-8__nOPQf","pt12":"Row_pt12__9roAs","pt-12":"Row_pt-12__GiABF","pt16":"Row_pt16__f56o2","pt-16":"Row_pt-16__Tgpbk","pt20":"Row_pt20__TDpx6","pt24":"Row_pt24__LB97U","pt32":"Row_pt32__p0CB3","pt36":"Row_pt36__MTU3v","pt40":"Row_pt40__rRqIb","pt48":"Row_pt48__YzL9_","pr0":"Row_pr0__sO7Zm","pr-2":"Row_pr-2__ziUhW","pr2":"Row_pr2__uSej3","pr4":"Row_pr4__Rr_Q9","pr-4":"Row_pr-4__MZEgH","pr8":"Row_pr8__RZwm8","pr-8":"Row_pr-8__9f2MU","pr12":"Row_pr12__fUFE2","pr-12":"Row_pr-12__rQn3X","pr16":"Row_pr16__URTNg","pr-16":"Row_pr-16__nE_Tg","pr20":"Row_pr20__Q1ynj","pr24":"Row_pr24__Dptk3","pr32":"Row_pr32__ttsJT","pr36":"Row_pr36__rtDTx","pr40":"Row_pr40__V1sug","pr48":"Row_pr48__QvF2u","pb0":"Row_pb0__a_Ub_","pb-2":"Row_pb-2___oQ_8","pb2":"Row_pb2__5nhw8","pb4":"Row_pb4__0uZ9x","pb-4":"Row_pb-4__L1wzH","pb8":"Row_pb8__C8l1O","pb-8":"Row_pb-8__IujDY","pb12":"Row_pb12__54Ob4","pb-12":"Row_pb-12__hP2kj","pb16":"Row_pb16__OYpw2","pb-16":"Row_pb-16__m6rVY","pb20":"Row_pb20__QH0CT","pb24":"Row_pb24__HpqFq","pb32":"Row_pb32__A0KTL","pb48":"Row_pb48__lxbva","pb36":"Row_pb36__n9eXi","pb40":"Row_pb40__eNVKH","pl0":"Row_pl0__U_gLD","pl-2":"Row_pl-2__tHC3_","pl2":"Row_pl2__j7dk0","pl4":"Row_pl4__wZlMf","pl-4":"Row_pl-4__x_bNv","pl8":"Row_pl8__l57Uj","pl-8":"Row_pl-8__FyLRl","pl12":"Row_pl12__1TTmI","pl-12":"Row_pl-12__x8FM0","pl16":"Row_pl16__q0Hsg","pl-16":"Row_pl-16___kJuZ","pl20":"Row_pl20__bNtzU","pl24":"Row_pl24__VQ7FD","pl32":"Row_pl32__mPcRs","pl36":"Row_pl36__L4rvh","pl40":"Row_pl40__aBfkz","pl48":"Row_pl48__HtAa8","fs12":"Row_fs12__A4MP7","fs14":"Row_fs14__mZeI8","fs16":"Row_fs16__gycHe","fs18":"Row_fs18__Vn9cz","fs20":"Row_fs20___f6qQ","fs24":"Row_fs24__9v1rU","fs32":"Row_fs32___AtGT","lh16":"Row_lh16__owSqW","lh20":"Row_lh20__XL57d","lh24":"Row_lh24__uc81G","lh32":"Row_lh32__DPWhk","lh40":"Row_lh40__NxqIl","w16":"Row_w16__KmQ5g","w32":"Row_w32__sxM2g","w36":"Row_w36__Gz3DO","w48":"Row_w48__9eCWl","h16":"Row_h16__4aCzW","h24":"Row_h24__nLCQf","h32":"Row_h32__PsKHZ","h40":"Row_h40__t5CXZ","h48":"Row_h48__DJiVB","br2":"Row_br2__sd2q_","br4":"Row_br4__Yditc","br8":"Row_br8__w3lDZ","br16":"Row_br16__Zrvkb","br24":"Row_br24__HoVhC","br32":"Row_br32__Vn3rK","zi100":"Row_zi100__aHPjT","zi200":"Row_zi200__jV9nG","clearfix":"Row_clearfix__UK73J","ell":"Row_ell__U7TmP","ells":"Row_ells__LWHQz","_1":"Row__1__zcY_g","_2":"Row__2__gBMwq","_3":"Row__3__eQfLW","_4":"Row__4___ZA_w","_5":"Row__5__qhiBa","c_primary":"Row_c_primary__QpDmW","c_l":"Row_c_l__8LAXX","c_m":"Row_c_m__C_fJk","c_s":"Row_c_s__q56FI","ywfont":"Row_ywfont__8H3gJ","container":"Row_container__tsttn"};

/***/ }),

/***/ 31518:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"Tabs_nav__qmUqM","tabsLayout":"Tabs_tabsLayout__e3viI","leftShadow":"Tabs_leftShadow__VTa97","rightShadow":"Tabs_rightShadow__GfUaS","tabs":"Tabs_tabs__ZKtpQ","tab":"Tabs_tab__tvJbf","indicator":"Tabs_indicator__XASJ7"};

/***/ }),

/***/ 93704:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"PopularTags_header__ljzZT","list":"PopularTags_list__ktfx4","extraRight":"PopularTags_extraRight__d36RB"};

/***/ }),

/***/ 66977:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title_card":"TitleCard_title_card__njgZK","title":"TitleCard_title__U8Us3","title_desc":"TitleCard_title_desc__SH_D1"};

/***/ }),

/***/ 51836:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"responsiveWrap":"SubjectDetail_responsiveWrap__36ny2"};

/***/ }),

/***/ 85165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container__wid7E","item":"List_item__WnIVR"};

/***/ }),

/***/ 5914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"responsiveWrap":"SubjectList_responsiveWrap__PIt7C","tabBarItem":"SubjectList_tabBarItem__1V6ns","subjectList":"SubjectList_subjectList__KjoGZ"};

/***/ }),

/***/ 47027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pl": function() { return /* binding */ prepare; }
/* harmony export */ });
/* unused harmony exports defineConfig, FileData, parseRequestData */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(705);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76080);



/**
 * 定义配置。
 *
 * @param config 配置
 */
function defineConfig(config, hooks) {
  if (hooks) {
    Object.defineProperty(config, 'hooks', {
      value: hooks,
      configurable: false,
      enumerable: false,
      writable: false
    });
  }

  return config;
}
var FileData = /*#__PURE__*/function () {
  /**
   * 原始文件数据。
   */

  /**
   * 选项。
   */

  /**
   * 文件数据辅助类，统一网页、小程序等平台的文件上传。
   *
   * @param originalFileData 原始文件数据
   * @param options 若使用内部的 getFormData，则选项会被其使用
   */
  function FileData(originalFileData, options) {
    this.originalFileData = void 0;
    this.options = void 0;
    this.originalFileData = originalFileData;
    this.options = options;
  }
  /**
   * 获取原始文件数据。
   *
   * @returns 原始文件数据
   */


  var _proto = FileData.prototype;

  _proto.getOriginalFileData = function getOriginalFileData() {
    return this.originalFileData;
  }
  /**
   * 获取选项。
   */
  ;

  _proto.getOptions = function getOptions() {
    return this.options;
  };

  return FileData;
}();
/**
 * 解析请求数据，从请求数据中分离出普通数据和文件数据。
 *
 * @param requestData 要解析的请求数据
 * @returns 包含普通数据(data)和文件数据(fileData)的对象，data、fileData 为空对象时，表示没有此类数据
 */

function parseRequestData(requestData) {
  var result = {
    data: {},
    fileData: {}
  };
  /* istanbul ignore else */

  if (requestData != null) {
    if (typeof requestData === 'object' && !Array.isArray(requestData)) {
      Object.keys(requestData).forEach(function (key) {
        if (requestData[key] && requestData[key] instanceof FileData) {
          result.fileData[key] = requestData[key].getOriginalFileData();
        } else {
          result.data[key] = requestData[key];
        }
      });
    } else {
      result.data = requestData;
    }
  }

  return result;
}

var queryStringify = function queryStringify(key, value, arrayFormat) {
  var str = '';

  if (value != null) {
    if (!Array.isArray(value)) {
      str = encodeURIComponent(key) + "=" + encodeURIComponent(value);
    } else if (arrayFormat === _types__WEBPACK_IMPORTED_MODULE_0__/* .QueryStringArrayFormat.indices */ .s0.indices) {
      str = value.map(function (v, i) {
        return encodeURIComponent(key + "[" + i + "]") + "=" + encodeURIComponent(v);
      }).join('&');
    } else if (arrayFormat === _types__WEBPACK_IMPORTED_MODULE_0__/* .QueryStringArrayFormat.repeat */ .s0.repeat) {
      str = value.map(function (v) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(v);
      }).join('&');
    } else if (arrayFormat === _types__WEBPACK_IMPORTED_MODULE_0__/* .QueryStringArrayFormat.comma */ .s0.comma) {
      str = encodeURIComponent(key) + "=" + encodeURIComponent(value.join(','));
    } else if (arrayFormat === _types__WEBPACK_IMPORTED_MODULE_0__/* .QueryStringArrayFormat.json */ .s0.json) {
      str = encodeURIComponent(key) + "=" + encodeURIComponent(JSON.stringify(value));
    } else {
      str = value.map(function (v) {
        return encodeURIComponent(key + "[]") + "=" + encodeURIComponent(v);
      }).join('&');
    }
  }

  return str;
};
/**
 * 准备要传给请求函数的参数。
 */


function prepare(requestConfig, requestData) {
  var requestPath = requestConfig.path;

  var _parseRequestData = parseRequestData(requestData),
      data = _parseRequestData.data,
      fileData = _parseRequestData.fileData;

  var dataIsObject = data != null && typeof data === 'object' && !Array.isArray(data);

  if (dataIsObject) {
    // 替换路径参数
    if (Array.isArray(requestConfig.paramNames) && requestConfig.paramNames.length > 0) {
      Object.keys(data).forEach(function (key) {
        if (requestConfig.paramNames.indexOf(key) >= 0) {
          // ref: https://github.com/YMFE/yapi/blob/master/client/containers/Project/Interface/InterfaceList/InterfaceEditForm.js#L465
          requestPath = requestPath.replace(new RegExp("\\{" + key + "\\}", 'g'), data[key]).replace(new RegExp("/:" + key + "(?=/|$)", 'g'), "/" + data[key]);
          delete data[key];
        }
      });
    } // 追加查询参数到路径上


    var queryString = '';

    if (Array.isArray(requestConfig.queryNames) && requestConfig.queryNames.length > 0) {
      Object.keys(data).forEach(function (key) {
        if (requestConfig.queryNames.indexOf(key) >= 0) {
          if (data[key] != null) {
            queryString += "" + (queryString ? '&' : '') + queryStringify(key, data[key], requestConfig.queryStringArrayFormat);
          }

          delete data[key];
        }
      });
    }

    if (queryString) {
      requestPath += "" + (requestPath.indexOf('?') > -1 ? '&' : '?') + queryString;
    }
  } // 全部数据


  var allData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, dataIsObject ? data : {}, fileData); // 获取表单数据


  var getFormData = function getFormData() {
    var useNativeFormData = typeof FormData !== 'undefined';
    var useNodeFormData = !useNativeFormData && // https://github.com/fjc0k/vtils/blob/master/src/utils/inNodeJS.ts
    typeof __webpack_require__.g === 'object' && typeof __webpack_require__.g['process'] === 'object' && typeof __webpack_require__.g['process']['versions'] === 'object' && __webpack_require__.g['process']['versions']['node'] != null;
    var UniFormData = useNativeFormData ? FormData : useNodeFormData ? eval("require('form-data')") : undefined;

    if (!UniFormData) {
      throw new Error('当前环境不支持 FormData');
    }

    var formData = new UniFormData();
    Object.keys(data).forEach(function (key) {
      formData.append(key, data[key]);
    });
    Object.keys(fileData).forEach(function (key) {
      var options = requestData[key].getOptions();
      var files = Array.isArray(fileData[key]) ? fileData[key] : [fileData[key]];
      files.forEach(function (file) {
        formData.append(key, file, useNativeFormData ? options == null ? void 0 : options.filename : options);
      });
    });
    return formData;
  };

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, requestConfig, {
    path: requestPath,
    rawData: requestData,
    data: data,
    hasFileData: fileData && Object.keys(fileData).length > 0,
    fileData: fileData,
    allData: allData,
    getFormData: getFormData
  });
}

/***/ }),

/***/ 76080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Py": function() { return /* binding */ RequestBodyType; },
/* harmony export */   "b": function() { return /* binding */ ResponseBodyType; },
/* harmony export */   "n$": function() { return /* binding */ Method; },
/* harmony export */   "s0": function() { return /* binding */ QueryStringArrayFormat; }
/* harmony export */ });
/* unused harmony exports Required, RequestParamType, RequestQueryType, RequestFormItemType */
/** 请求方式 */
var Method;
/** 是否必需 */

(function (Method) {
  Method["GET"] = "GET";
  Method["POST"] = "POST";
  Method["PUT"] = "PUT";
  Method["DELETE"] = "DELETE";
  Method["HEAD"] = "HEAD";
  Method["OPTIONS"] = "OPTIONS";
  Method["PATCH"] = "PATCH";
})(Method || (Method = {}));

var Required;
/** 请求数据类型 */

(function (Required) {
  Required["false"] = "0";
  Required["true"] = "1";
})(Required || (Required = {}));

var RequestBodyType;
/** 请求路径参数类型 */

(function (RequestBodyType) {
  RequestBodyType["query"] = "query";
  RequestBodyType["form"] = "form";
  RequestBodyType["json"] = "json";
  RequestBodyType["text"] = "text";
  RequestBodyType["file"] = "file";
  RequestBodyType["raw"] = "raw";
  RequestBodyType["none"] = "none";
})(RequestBodyType || (RequestBodyType = {}));

var RequestParamType;
/** 请求查询参数类型 */

(function (RequestParamType) {
  RequestParamType["string"] = "string";
  RequestParamType["number"] = "number";
})(RequestParamType || (RequestParamType = {}));

var RequestQueryType;
/** 请求表单条目类型 */

(function (RequestQueryType) {
  RequestQueryType["string"] = "string";
  RequestQueryType["number"] = "number";
})(RequestQueryType || (RequestQueryType = {}));

var RequestFormItemType;
/** 返回数据类型 */

(function (RequestFormItemType) {
  RequestFormItemType["text"] = "text";
  RequestFormItemType["file"] = "file";
})(RequestFormItemType || (RequestFormItemType = {}));

var ResponseBodyType;
/** 查询字符串数组格式化方式 */

(function (ResponseBodyType) {
  ResponseBodyType["json"] = "json";
  ResponseBodyType["text"] = "text";
  ResponseBodyType["xml"] = "xml";
  ResponseBodyType["raw"] = "raw";
})(ResponseBodyType || (ResponseBodyType = {}));

var QueryStringArrayFormat;
/** 接口定义 */

(function (QueryStringArrayFormat) {
  QueryStringArrayFormat["brackets"] = "brackets";
  QueryStringArrayFormat["indices"] = "indices";
  QueryStringArrayFormat["repeat"] = "repeat";
  QueryStringArrayFormat["comma"] = "comma";
  QueryStringArrayFormat["json"] = "json";
})(QueryStringArrayFormat || (QueryStringArrayFormat = {}));

/***/ }),

/***/ 705:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ })

}]);